import { Col, Row, Typography, message } from "antd"
import PropTypes from "prop-types"
import React from "react"
import { useParams } from "react-router-dom"
import styled from "styled-components"

import { LoadingOutlined } from "@ant-design/icons"

import StyledAppButton from "../../../_shared/components/AppButton"
import AppInput from "../../../_shared/components/FormItems/AppInput"
import useForm from "../../../_shared/hooks/useForm"
import useRestResource from "../../../_shared/hooks/useRestResource"

const { Title } = Typography

// ----------------------------------------------------------------------------

function _PasswordReset(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { className, onSubmit, Error } = props

    // -------------------------------------
    // Hooks (e.g. useState, ...)
    // -------------------------------------
    const [formValues, setFormValue] = useForm({
        password: "",
        confirmPassword: "",
    })

    const params = useParams()

    const [requestInfo, , loading, , error] = useRestResource(
        `/password-reset-requests`,
        params.token
    )

    // -------------------------------------
    // Memoized values
    // -------------------------------------

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    function handleSubmit(e) {
        e.preventDefault()
        const { password, confirmPassword } = formValues
        if (password !== confirmPassword) {
            message.error("Le password non combaciano")
            return
        }
        onSubmit && onSubmit(password, params.token)
    }

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    if (loading) {
        return (
            <form>
                <LoadingOutlined />
            </form>
        )
    }

    if (requestInfo?.usedAt) {
        return (
            <form>
                <Title level={3}>Questo token è già stato usato</Title>
            </form>
        )
    }

    if (error?.statusCode === 404) {
        return (
            <form>
                <Title level={3}>
                    Il codice fornito per il recupero della password è scuduto o
                    non valido.
                </Title>
            </form>
        )
    }

    return (
        <form onSubmit={handleSubmit} className={`${className}`}>
            <div className="form-item">
                <div className="form-item">
                    <Title level={3}>Recupera la tua password</Title>
                    {Error}
                    <Row gutter={12}>
                        <Col span={24}>
                            <AppInput
                                label="Password"
                                value={formValues?.password}
                                required={true}
                                onChange={(value) => {
                                    setFormValue("password", value)
                                }}
                                type="password"
                            />
                            <AppInput
                                label="Ripeti password"
                                value={formValues?.confirmPassword}
                                required={true}
                                onChange={(value) => {
                                    setFormValue("confirmPassword", value)
                                }}
                                type="password"
                            />
                        </Col>
                    </Row>
                </div>
                <div className="form-item">
                    <StyledAppButton className="primary" type="submit">
                        Conferma
                    </StyledAppButton>
                </div>
            </div>
        </form>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_PasswordReset.propTypes = {
    className: PropTypes.string.isRequired,
    onSubmit: PropTypes.func,
    Error: PropTypes.func,
}

_PasswordReset.defaultProps = {}

// ----------------------------------------------------------------------------

const PasswordReset = styled(_PasswordReset)`
    & {
    }
`
// ----------------------------------------------------------------------------

export default PasswordReset
